// extracted by mini-css-extract-plugin
export default {"wrapper1":"Schedule_wrapper1__SYKLt","wrapper2":"Schedule_wrapper2__ELwZX","container":"Schedule_container__oai0s","update":"Schedule_update__eTcJj"};